var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalaDeEsperaAzul(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 264,
    viewBox: "0 0 282 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 282,
    height: 264,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "translate(-0.000981646) scale(0.000251119)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 3990,
    height: 3728,
    xlinkHref: "https://i.ibb.co/QkRpVXG/image.png/"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalaDeEsperaAzul);
export default __webpack_public_path__ + "static/media/salaDeEsperaAzul.44cceecbed1532035d2bc23bfcbcb3d9.svg";
export { ForwardRef as ReactComponent };